import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
/* react-datepicker ships its own stylesheet. It used to be imported inside the
   offers chunk only, so every picker in another lazy chunk rendered unstyled. */
import "react-datepicker/dist/react-datepicker.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import {store} from "./store/store";
import "./utils/localization/i18n";
import "./utils/yupLocale";
import {ErrorBoundary} from "./ErrorBoundary";
import {installChunkErrorHandler} from "./utils/chunkError";

installChunkErrorHandler();

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Provider store={store}>
                <ErrorBoundary>
                    <App/>
                </ErrorBoundary>
            </Provider>
        </BrowserRouter>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
